import type { FC } from "react";
import { Illustration } from "../Illustration";
import { Section } from "../Section";
import {
  Card,
  Container,
  type ContainerProps,
  Flex,
  Heading,
  Spacing,
} from "@huub-web/ui";
import { useTranslation } from "react-i18next";

export type MaximumMortgageWizardResultLoadingScreenProps = {
  container?: ContainerProps["size"];
};

export const MaximumMortgageWizardResultLoadingScreen: FC<
  MaximumMortgageWizardResultLoadingScreenProps
> = ({ container = "marketingS" }) => {
  const { t } = useTranslation();

  return (
    <Section variant="tint" style={{ minHeight: "100%" }}>
      <Container size={container} grow>
        <Card border="default" overflowHidden>
          <Flex direction="column" gap="xs" align="center">
            <Illustration
              name="calculating"
              alt={t("maxMortgageWizard.result.loading.alt")}
              alignSelf="center"
            />
            <Heading
              variant="secondary"
              title={t("maxMortgageWizard.result.loading.title")}
              align="center"
            />
            <Spacing height="m" />
          </Flex>
        </Card>
      </Container>
    </Section>
  );
};
